import { history, IHistoryState } from '@app/app.routes';
import { IconButton } from '@material-ui/core';
import { Location, UnregisterCallback } from 'history';
import * as React from 'react';
import Icon from '../shared/icon.component';

class NavigationBackButton extends React.Component<any, { showBackButton: boolean }> {
	private pathToMatch: string[] = [];
	private unregisterCallback: UnregisterCallback = null;

	constructor(props: Readonly<{}>) {
		super(props);
		this.state = {
			showBackButton: false,
		};
	}

	public componentDidMount() {
		this.unregisterCallback = history.listen((loc: Location<IHistoryState>) => {
			if (this.pathToMatch.includes(loc.pathname)) {
				this.setState({
					showBackButton: true,
				});
			} else {
				this.setState({
					showBackButton: false,
				});
			}
		});
	}

	public componentWillUnmount() {
		this.unregisterCallback();
	}

	public render() {
		const showBackButton = this.state.showBackButton;

		return (
			<React.Fragment>
				{showBackButton && (
					<IconButton color='inherit' onClick={() => this.navigateBack()}>
						<Icon name="arrow-left" />
					</IconButton>
				)}
			</React.Fragment>
		);
	}

	private navigateBack() {
		history.goBack();
	}
}

export default NavigationBackButton;



// WEBPACK FOOTER //
// ./src/components/core/navigationbackbutton.component.tsx